import { createContext, useContext, useState } from 'react';
import { IAlert } from '@greatmindsorg/atomic-ui-lib-lts';

type IToastState = Omit<IAlert, 'alertType'>;

const INITIAL_CONFIG: IToastState = {
  content: {
    title: '',
    message: '',
  },
  alertVariant: 'neutral',
  customIcon: null,
  visible: false,
  FirstAction: null,
  SecondAction: null,
  handleClose: null,
};

interface IToastContext {
  toastProps: IToastState;
  closeToast: () => void;
  showToast: (toastProps: Partial<IToastState>) => void;
}

export const ToastContext = createContext<IToastContext>({
  toastProps: INITIAL_CONFIG,
  closeToast: null,
  showToast: null,
});

export const ToastProvider = ({ children }) => {
  const [toastState, setToastState] = useState<IToastState>(INITIAL_CONFIG);

  const showToast = (newToastState: Partial<IToastState>) => {
    setToastState(prevToastState => ({
      ...prevToastState,
      ...newToastState,
      visible: true,
    }));
  };

  const closeToast = () => {
    setToastState({
      ...INITIAL_CONFIG,
    });
  };

  return (
    <ToastContext.Provider value={{ toastProps: toastState, closeToast, showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
